import { contacts, partners } from '../../../services/api.admin';
import { fetchTableData, deleteTableData } from '../tables';
import { MODELS } from '../../../constants/admin/settings';
import { apiDataToState, stateToApiData } from '../../../selectors/admin/models/contacts';
import { fetchModel, submit, fetchDependencies } from '../forms';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import { push } from 'react-router-redux';
import { ADMIN_ORG_CONTACTS_DETAILS_PATH, ADMIN_CONTACTS_DETAILS_PATH } from '../../../constants/routes';
import { artists } from '../../../services/api.admin';

export function fetchList(contextId, pagination) {
    return fetchTableData(
        contextId ? () => contacts.getOrg(contextId, pagination) : () => contacts.get(pagination),
        'users',
        {
            pagination
        }
    );
}

export function fetchContactDependencies(context) {
    return fetchDependencies([
        context ? () => artists.getOrgAll(context) : artists.getAll,
        context ? () => partners.getOrgAll(context) : partners.getAll
    ]);
}

export function deleteContacts() {
    return deleteTableData(contacts.delete, MODELS.CONTACT);
}

export function create(data) {
    return submit(() => contacts.create(stateToApiData(data)), 'Contact successfully created.', {
        goToDetails: true
    });
}

export function update(data, id) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return submit(() => contacts.update(id, stateToApiData(data), context), 'Contact successfully updated.')(
            dispatch,
            getState
        );
    };
}

export function fetchMember(id) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return fetchModel(() => contacts.getMember(id, context), MODELS.CONTACT, {
            transform: apiDataToState
        })(dispatch);
    };
}

export function goToContact(contact) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        dispatch(
            push(
                context
                    ? ADMIN_ORG_CONTACTS_DETAILS_PATH.replace(':context', context).replace(':contactId', contact.id)
                    : ADMIN_CONTACTS_DETAILS_PATH.replace(':contactId', contact.id)
            )
        );
    };
}



// WEBPACK FOOTER //
// ./src/actions/admin/models/contacts.js